import { Button, Card, CardGroup } from "react-bootstrap";
import { Reveal, Fade, Bounce } from "react-awesome-reveal";

export const Price = () => {
  return (
    <section id="price">
      <div className="container py-5" style={{ maxWidth: "1100px" }}>
        <div
          // style={{ fontWeight: "800" }}
          className="border-bottom border-3 border-warning"
        >
          <div className="text-center mt-4 mb-5">
            <div className="h2">
              <span className="border-bottom border-info border-3">Price.</span>
            </div>
            <p>料金紹介</p>
          </div>
          <div className="mx-2">※税込料金</div>
          <CardGroup className="text-center rounded-0">
            <Card className="mx-2 border">
              <Fade triggerOnce left>
                <Card.Header className="bg-primary text-white fs-5 rounded-0 py-4">
                  ツール開発(ライト)
                </Card.Header>
                <Card.Body className="p-0">
                  <Card.Title className="m-0 py-5 fs-3">22,000円</Card.Title>
                  <Card.Text className="py-3 bg-light">
                    単一プログラム作成
                  </Card.Text>
                  <Card.Text>サービス内成形アシスト</Card.Text>
                  <Card.Text className="py-3 bg-light">
                    改修(修正)作業
                  </Card.Text>
                  <Card.Text className="pb-3">
                    (例)スプレッドシート成形
                  </Card.Text>
                </Card.Body>
              </Fade>
            </Card>
            <Card className="mx-2 border">
              <Reveal triggerOnce>
                <Card.Header className="bg-warning text-white fs-5 py-4">
                  ツール開発(標準)
                </Card.Header>
                <Card.Body className="p-0">
                  <Card.Title className="m-0 py-5 fs-3">44,000円</Card.Title>
                  <Card.Text className="py-3 bg-light">
                    複数プログラム作成
                  </Card.Text>
                  <Card.Text>各Googleサービス連携</Card.Text>
                  <Card.Text className="py-3 bg-light">
                    データツール開発
                  </Card.Text>
                  <Card.Text className="pb-3">
                    (例)メール本文の情報抽出
                  </Card.Text>
                </Card.Body>
              </Reveal>
            </Card>
            <Card className="mx-2 border">
              <Fade triggerOnce right>
                <Card.Header className="bg-primary text-white fs-5 py-4">
                  システム開発
                </Card.Header>
                <Card.Body className="p-0">
                  <Card.Title className="m-0 py-5 fs-3">132,000円～</Card.Title>
                  <Card.Text className="py-1 bg-light">
                    Googleサービスでの
                    <br />
                    システム開発
                  </Card.Text>
                  <Card.Text>予約管理システム</Card.Text>
                  <Card.Text className="py-3 bg-light">
                    業務管理ステム
                  </Card.Text>
                  <Card.Text className="pb-3">
                    (例)顧客管理＆
                    <br />
                    スケジュール管理システム
                  </Card.Text>
                </Card.Body>
              </Fade>
            </Card>
            <Card className="mx-2 border rounded-0">
              <Fade triggerOnce right>
                <Card.Header className="bg-primary text-white fs-5 rounded-0 py-4">
                  ツール・システム点検
                </Card.Header>
                <Card.Body className="p-0">
                  <Card.Title className="m-0 py-5 fs-3">
                    10,000円/
                    <span className="fs-5">
                      4回分
                      <br />
                      (又は、3,000円/1回)
                    </span>
                  </Card.Title>
                  <Card.Text className="py-3 bg-light">
                    エラー原因究明
                  </Card.Text>
                  <Card.Text>改善方法の提案</Card.Text>
                  <Card.Text className="py-3 bg-light">
                    コンサルティング
                  </Card.Text>
                  <Card.Text className="pb-3">簡易修正</Card.Text>
                </Card.Body>
              </Fade>
            </Card>
          </CardGroup>
          <div className="mx-2 pb-5">
            作成時間及びプログラム量により追加で料金が発生する場合があります。
            <br />
            上記以外にもWebデザイン・フロントエンド開発、保守業務も行っております。お気軽にご相談・お問い合わせください。
          </div>
          <div className="my-5 pb-2 text-center fs-5">
            多数のクライアント様から想像通りのものが出来ると仰っていただき、
            <br />
            納品の早さと修正の迅速な対応にご好評いただいております。
          </div>
          <div className="text-center pb-5">
            <Bounce triggerOnce>
              <Button
                variant="danger"
                className="mx-auto rounded-pill btn-lg my-5 px-4 py-3 fs-4"
                href="/#form"
              >
                　相談する　
              </Button>
            </Bounce>
          </div>
        </div>
      </div>
    </section>
  );
};
